const aboutFrench = () => (
  {
    servicesTitle: 'Mes services',
    title: {
      part1: 'MA MISSION EST DE',
      part2: 'CONCEVOIR ET DÉVELOPPER LES MEILLEURS SITES WEB',
      part3: 'DU MARCHÉ',
    },
    description: 'Je peux vous aider à construire un produit, une fonctionnalité \
      ou un site web. Parcourez certains de mes travaux et de mes expériences! Si vous \
      aimez ce que vous voyez et que vous avez un projet à coder, n\'hésitez pas à me contacter.',
    resume: 'Obtenez mon CV',
    skills: {
      language: 'Langages',
      framework: 'Frameworks',
      tools: 'Outils',
    },
  }
);

export default aboutFrench;
